import { useEffect } from 'react';

const ClickCount = ({ clicks, onComplete, totalClicks = 10 }) => { // TOTAL CLICKS MUST BE DIVISIBLE BY 2
    const dividers = totalClicks / 2;
    const degPerDivider = 360 / dividers;

    useEffect(() => {
        if (clicks >= totalClicks) {
            onComplete();
        }
    }, [clicks]);

    return (
        <div
            className="w-24 h-24 lg:w-40 lg:h-40 rounded-full flex items-center justify-center flex-col text-white border-progress relative"
            style={{
                '--p': (clicks / totalClicks) * 100,
            }}
        >
            {[...new Array(dividers)].map((_, k) => (
                <div
                    key={k}
                    className="absolute top-0 bottom-0 w-1 h-full bg-white bg-app-turquoise"
                    style={{
                        transform: `rotate(${degPerDivider * k}deg)`,
                    }}
                />
            ))}

            <div className="w-full h-full bg-app-turquoise rounded-full flex items-center justify-center flex-col relative z-10">
                <div className="text-xl lg:text-6xl font-bold nobblee-bold">
                    {clicks}
                </div>

                <div className="uppercase text-app-green text-xs lg:text-lg text-center">
                    Clicks <br />
                    Used
                </div>
            </div>
        </div>
    );
};

export default ClickCount;
